import React, { useCallback, useEffect, useState } from "react";
import throttle from "lodash/throttle";
import "rc-pagination/assets/index.css";
import storage from "@/utils/storage";
import axios from "axios";
import "./transaction.css";
import MervIcon from "@/assets/mervIcon.svg";
import { useWalletAmount } from "@/components/Elements/api/getWalletamount";
import { useInvestedCoins } from "../api/getInvestedCoins";
import yellowt from "@/assets/yellow-t.png";
import CurrencyFormat from "react-currency-format";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import styled from "styled-components";
import moment from "moment";
import Pagination from "rc-pagination";
const tableHead = {
  txId: "Transaction Id",
  cryptoType: "Currency",
  amount: "Deposit Amount ",
  walletAddress: "Payment Address",
  paymentType: "Payment Type",
  convertedAmount: "Received Amount (USDC)",
  paymentStatus: "Status",
  createdAt: "Payment Date",
};

const MyPayments = () => {
  const limit = 10;
  const dataWallet = useWalletAmount({});
  const coins = useInvestedCoins({});
  const [value, setValue] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
 const [totalItems, setTotalItems] = useState(0);
  const [data, setData] = useState([{}]);
  const [loading, setLoading] = useState(false);
  console.log(loading, "loading");

  useEffect(() => {
    getData(currentPage, value);
  }, [currentPage, value]);

  const getData = async (page, searchQuery) => {
    try {
      setLoading(true);

      const token = storage.getToken();
      const response = await axios.get(
        `${process.env.API_URL_PREFIX}/api/v1/user/getDepositWithdrawList`,
        {
         params: {
            limit: limit,
            page: page,
            search: "", 
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );

      setData(response?.data?.ipnData || []);
      setTotalItems(response?.data?.metaData?.[0]?.totalDoc || 0);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = useCallback(
    throttle((searchTerm) => {
      setValue(searchTerm);
      setCurrentPage(1);
    }, 500),
    []
  );

  const updatePage = (page) => {
    setCurrentPage(page);
  };

  const formatDate = (date) => {
    return date ? moment(date).format("DD/MM/YYYY") : "N/A";
  };



  const tableRows = ({ key, index }) => {
    const tableCell = Object.keys(tableHead);
    const columnData = tableCell.map((keyD, i) => {
      let cellValue = key[keyD];

      // Format date for createdAt column
      if (keyD === "createdAt") {
        cellValue = cellValue ? moment(cellValue).format("DD/MM/YYYY") : "N/A";
      }

      return (
        <td key={i} className="td">
          {cellValue}
        </td>
      );
    });

    return (
      <tr key={index} style={{ textAlign: "center" }}>
        {columnData}
      </tr>
    );
  };

  const tableData = () => {
    return data.map((key, index) => tableRows({ key, index }));
  };

  const headRow = () => {
    return Object.values(tableHead).map((title, index) => (
      <td key={index}>
        <div className="m-auto minw-maxcontent">{title}</div>
      </td>
    ));
  };

  const Item = styled(Paper)(({ theme }) => ({
    background: "transparent",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  }));
  var cardStyle = {
    display: "block",
    transitionDuration: "0.3s",
    height: "auto",
    background: "#050518",
    boxShadow: "0 0 10px #8264eeb3",
    borderRadius: "20px",
  };
  return (
    <>
      <Box
        sx={{
          display: { md: "flex", xs: "none" },
        }}
      >
        <input
          placeholder="Search"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="search"
        />
      </Box>
      <Box sx={{ height: "auto", marginTop: "10px" }}>
        <Card style={cardStyle}>
          <CardContent sx={{ padding: { xs: "10px", md: "20px" } }}>
            <Grid container justifyContent={"space-between"}>
              <Grid
                item
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  gap: "10px",
                }}
              >
                <Typography
                  component="h4"
                  sx={{
                    fontSize: {
                      xs: "14px !important",
                      md: "16px !important",
                      lg: "20px !important",
                    },
                  }}
                >
                  My Payments
                </Typography>
                <Box
                  sx={{
                    display: { md: "none", xs: "flex" },
                  }}
                >
                  <input
                    placeholder="Search"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="search"
                    style={{
                      width: "auto",
                      maxWidth: "200px",
                      margin: "0px",
                      padding: "5px 10px",
                    }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                sx={{
                  display: "flex",
                  flexFlow: "column",
                  gap: "5px",
                  color: "#fff",
                  fontSize: {
                    xs: "14px !important",
                    md: "16px !important",
                    lg: "20px !important",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <img
                    src={MervIcon}
                    alt="merv-icon"
                    className="log-merv-wallet"
                    style={{
                      height: "auto",
                      width: "22px",
                    }}
                  />{" "}
                  {coins?.data?.data}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <img
                    src={yellowt}
                    alt="yellowt-icon"
                    className="log-merv-wallet"
                    style={{
                      height: "auto",
                      width: "22px",
                    }}
                  />
                  <CurrencyFormat
                    value={dataWallet?.data?.walletAmount}
                    thousandSeparator={"."}
                    displayType={"text"}
                    decimalSeparator={","}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box className="table-t1 sticky-table">
                <table
                  style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  {data.length > 0 && !loading && (
                    <thead>
                      <tr style={{ textAlign: "center" }}>{headRow()}</tr>
                    </thead>
                  )}
                  <tbody>
                    {loading ? (
                      <tr>
                        <td
                          colSpan={9}
                          style={{ height: "auto", textAlign: "center" }}
                        >
                          <CircularProgress size={80} />
                        </td>
                      </tr>
                    ) : data.length === 0 ? (
                      <tr>
                        <td colSpan={9}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="400px"
                            textAlign="center"
                          >
                            <Typography
                              variant="h6"
                              fontWeight="bold"
                              style={{ color: "#ff862d" }}
                            >
                              💳 No payment records found <br />
                              🚀 Start your first deposit and watch it appear here!
                            </Typography>
                          </Box>
                        </td>
                      </tr>
                    ) : (
                      <>{tableData()}</>
                    )}
                  </tbody>
                </table>
              </Box>
            </Grid><Box className="paginationBox">
        {!loading && totalItems > 0 && (
          <Pagination
            pageSize={limit}
            current={currentPage}
            total={totalItems}
            onChange={handlePageChange}
          />
        )}
      </Box>
          </CardContent>
           
        </Card>
      </Box>
    </>
  );
};
export default MyPayments;
